/* ==========================================================
   REBELLE — panier (amélioration progressive)
   Tiroir = section Liquid `cart-drawer`, re-rendue via la Section
   Rendering API. On ne construit AUCUN balisage panier ici.
   Expose window.RebelleCart pour rebelle-product.js.
   ========================================================== */
(function () {
  var SECTION_ID = 'cart-drawer';
  var isOpen = false;

  function wrapper() { return document.getElementById('shopify-section-' + SECTION_ID); }
  function panel() { var w = wrapper(); return w ? w.querySelector('[data-cart-drawer]') : null; }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    // Le bouton panier n'apparaît que si le panier contient des articles.
    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.toggleAttribute('hidden', count === 0);
    });
  }

  function open() {
    var p = panel();
    if (!p) return;
    p.classList.add('on');
    p.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    var close = p.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function close() {
    var p = panel();
    if (!p) return;
    p.classList.remove('on');
    p.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;
  }

  // Remplace uniquement le corps + le pied du tiroir → conserve l'état ouvert,
  // pas de clignotement. Repli : remplace toute la section.
  function applySection(html) {
    var w = wrapper();
    if (!w || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cart-drawer]');
    var cur = panel();
    if (fresh && cur) {
      ['[data-drawer-body]', '[data-drawer-footer]'].forEach(function (sel) {
        var a = fresh.querySelector(sel);
        var b = cur.querySelector(sel);
        if (a && b) b.innerHTML = a.innerHTML;
      });
      cur.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    } else {
      w.innerHTML = html;
      if (isOpen) open();
    }
  }

  function sectionsPayload(form) {
    form.append('sections', SECTION_ID);
    form.append('sections_url', window.location.pathname);
  }

  function add(formData, onError) {
    sectionsPayload(formData);
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) { if (onError) onError(r.data); return; }
        if (r.data.sections && r.data.sections[SECTION_ID]) applySection(r.data.sections[SECTION_ID]);
        return syncCount().then(open);
      })
      .catch(function () { /* réseau : on laisse le repli natif au prochain essai */ });
  }

  function change(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION_ID, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.sections && cart.sections[SECTION_ID]) applySection(cart.sections[SECTION_ID]);
        updateCount(cart.item_count);
      });
  }

  function syncCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCount(cart.item_count); });
  }

  // Délégation : le contenu du tiroir se re-rend, on écoute au niveau document.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-overlay]')) { e.preventDefault(); close(); return; }
    var step = e.target.closest('[data-line-step]');
    if (step) { e.preventDefault(); change(parseInt(step.dataset.line, 10), parseInt(step.dataset.qty, 10)); return; }
    var rem = e.target.closest('[data-line-remove]');
    if (rem) { e.preventDefault(); change(parseInt(rem.dataset.line, 10), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  window.RebelleCart = { open: open, close: close, add: add, change: change, syncCount: syncCount };
})();
